import { DEFAULT_LANGUAGE } from '../shared/i18n/i18n.config';

export function getMatchingLanguage(locale: string, availableLanguages: string[]): string {
    if (availableLanguages.includes(locale)) {
        return locale;
    }

    const fallbackLang = locale.split('-')[0];
    if (availableLanguages.includes(fallbackLang)) {
        return fallbackLang;
    }

    return DEFAULT_LANGUAGE;
}
